import { Flexbox } from '@morressier/ts';

import styled from 'styled-components';

export const StyledTranscriptsHeader = styled(Flexbox).attrs({
  flexDirection: 'column',
})`
  width: 100%;
  align-self: center;
  padding-left: 1rem;
`;

export const StyledTranscripts = styled(Flexbox).attrs({
  flexDirection: 'column',
})`
  max-height: 20.75rem;
  overflow-y: scroll;
  padding: 1rem;
`;

export const StyledTranscriptBox = styled.div<{ highlight: boolean }>`
  padding: 0.25rem;
  margin-left: 1rem;
  border-radius: 3px;
  background: ${props => (props.highlight ? '#065de01A' : 'none')};
`;
